import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  ChatContainer,
  MessageList,
  MessageInput,
  Message,
  Avatar,
} from "@chatscope/chat-ui-kit-react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  createMessagesForTickets,
  getMessagesForTickets,
} from "../Services/Service";
import { MdHeight } from "react-icons/md";

function ChatUIComponent({ ticketInfo }) {
  const chatContainerRef = useRef({});
  const {id}=useParams();
  ticketInfo = { ticketNumber: 212 };
  const [messages, SetMessages] = useState([]);
  const [ticket, setTicket] = useState();
  const fetchMessages = async () => {
    try {
      const d = await getMessagesForTickets(id);
      console.log({ d });
      SetMessages(d.data.data);
      setTicket(d.data.tickets);
    } catch (error) {
      console.error("Error fetching messages:", error);
      // Handle error - e.g., set an error state, display an error message, etc.
    }
  };
  
  useEffect(() => {
    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    fetchMessages();
  }, []);
  console.log({ messages });
  //   const headerStyle = {
  //     backgroundColor: "#f0f0f0",
  //     padding: "10px",
  //     borderBottom: "1px solid #ccc",
  //     marginBottom: "10px",
  //     borderRadius: "8px",
  //   };

  const handleNewMessage = async (ticketId, message) => {
    const formData = new FormData();
    formData.append("message", message);
    const d = await createMessagesForTickets(ticketId, formData);
    fetchMessages();
    console.log({ d });
  };

  return (
    <div className="container">
    <div className="chat-container ">
      <div style={{background:' linear-gradient(to bottom right, var(--background-color), var(--background-header-color))', padding:'3vh'}}>
        <h3 style={{ margin: 0 }}>Ticket: {id}</h3>
        <h3 style={{ margin: 0 }}>Order Id: {ticket?.orderId}</h3>
        <h3 style={{ margin: 0 }}>App Id: {ticket?.appId}</h3>
        <h3 style={{ margin: 0 }}>Order Id: {ticket?.ticketStatus}</h3>
        <h3 style={{ margin: 0 }}>Order Id: {ticket?.feedback}</h3>
      </div>
      <div className="container" >

      <ChatContainer style={{minHeight:'55vh'}}>
        <MessageList>
          {messages.reverse().map((item, index) => (
            <Message
              key={index}
              model={{
                message: item.message,
                sentTime: "just now",
                sender: item.senderType,
                direction:
                  item.senderType === "Icespice" ? "incoming" : "outgoing",
                position: "first",
              }}
            >
              {item.senderType === "Icespice" && ( // Render Avatar only for icespice senderType
                <Avatar
                  src="https://appcdn.goqii.com/storeimg/28034_1677487993.png"
                  name="Joe"
                />
              )}
            </Message>
          ))}
        </MessageList>
        <MessageInput
          placeholder="Type your message..."
          attachButton={false}
          onSend={(value) => handleNewMessage(217, value)}
        />
      </ChatContainer>
      </div>
   
    </div>
    </div>
  );
}

export default ChatUIComponent;
